import { Box, Divider, TextButton } from "@wix/design-system";
import React, { useContext, useRef } from "react";
import { RicosContext } from "./../../../ricos-context";
import { useClickOutside } from "../../ClickOutside/useClickOutside";
import { FloatingLayout } from "../../modal-layout/floating-layout";
import { ColorSwatches } from "../common/color-swatches";
import { FLOATING_COLOR_SWATCHES, RESET_BUTTON } from "./data-hooks";
import classes from "./floating-color-picker-scss";
import { useCustomColorPickerModal } from "./floating-custom-color-picker/use-custom-color-picker-modal";
const FloatingColorPicker = ({
  title,
  currentColor,
  userColors,
  onChange,
  onReset,
  closeModal,
  referenceElement,
  allowEmpty
}) => {
  const { t, isMobile } = useContext(RicosContext);
  const modalRef = useRef(null);
  const customColorPicker = useCustomColorPickerModal({
    onClickOutside: closeModal,
    componentProps: {
      title,
      color: currentColor?.toUpperCase(),
      onConfirm: (color) => {
        if (!userColors.includes(color)) {
          onChange({ type: "colorAdded", color });
        }
        customColorPicker.closeModal();
      },
      allowEmpty
    }
  });
  const onClickOutside = (e) => {
    const target = e.target;
    if (target?.dataset?.hook === "tooltip-text" || target?.role === "tooltip" || referenceElement?.contains(target)) {
      return;
    }
    closeModal();
  };
  useClickOutside({
    containerRef: modalRef,
    onClickOutside,
    disable: customColorPicker.isModalOpen()
  });
  return /* @__PURE__ */ React.createElement(
    FloatingLayout,
    {
      onCloseButtonClick: closeModal,
      sidePanelProps: { height: "fit-content", width: isMobile ? "100%" : "240px" },
      dataHook: FLOATING_COLOR_SWATCHES,
      header: isMobile ? {
        title
      } : void 0,
      content: {
        noPadding: true,
        children: /* @__PURE__ */ React.createElement(Box, { ref: modalRef, direction: "vertical" }, /* @__PURE__ */ React.createElement(Box, { padding: isMobile ? "12px 24px" : "SP2", direction: "vertical" }, /* @__PURE__ */ React.createElement(
          ColorSwatches,
          {
            userColors,
            selectedColor: currentColor?.toUpperCase(),
            onAddClick: () => {
              customColorPicker.toggleModal(modalRef.current);
            },
            onChange: (color) => onChange({ type: "colorSelected", color }),
            size: isMobile ? "medium" : "small",
            allowEmpty
          }
        )), /* @__PURE__ */ React.createElement(Box, { paddingInline: "-24px", marginBlock: isMobile ? "12px" : void 0 }, /* @__PURE__ */ React.createElement(Divider, null)), /* @__PURE__ */ React.createElement(Box, { padding: isMobile ? "0px 24px 24px 24px" : "9px 12px" }, /* @__PURE__ */ React.createElement(
          TextButton,
          {
            onClick: () => {
              onReset();
              customColorPicker.closeModal();
            },
            underline: "always",
            size: isMobile ? "medium" : "tiny",
            className: classes.resetButton,
            dataHook: RESET_BUTTON
          },
          t("ColorPicker_SetToDefault_ButtonLabel")
        )))
      }
    }
  );
};
export {
  FloatingColorPicker
};
//# sourceMappingURL=floating-color-picker.js.map
